import { readContract, readContracts } from '@wagmi/core';

import { Address, erc20Abi, formatUnits } from 'viem';

import { wagmiConfig, WagmiConfigChain } from '@shared/common/providers/Web3Provider/wagmi';
import { DEFAULT_TARGET_CHAIN } from '@shared/constants';

export interface GetTokenResult {
  decimals: number;
  name: string;
  symbol: string;
  userTokenBalance: bigint;
  userTokenFormatted: string;
  address: Address;
}

export const defaultData = {
  decimals: 0,
  name: 'N/A',
  symbol: 'N/A',
  userTokenBalance: BigInt(0),
  userTokenFormatted: '0',
  address: '0x000' as Address,
};

export const getToken = async ({
  tokenAddress,
  walletAddress,
  chainId = DEFAULT_TARGET_CHAIN.id,
}: {
  tokenAddress?: Address;
  walletAddress?: Address;
  chainId?: WagmiConfigChain['id'];
}): Promise<GetTokenResult> => {
  if (!tokenAddress) {
    return defaultData;
  }

  try {
    const [decimals, name, symbol] = await readContracts(wagmiConfig, {
      allowFailure: false,
      contracts: [
        {
          address: tokenAddress,
          abi: erc20Abi,
          functionName: 'decimals',
          chainId,
        },
        {
          address: tokenAddress,
          abi: erc20Abi,
          functionName: 'name',
          chainId,
        },
        {
          address: tokenAddress,
          abi: erc20Abi,
          functionName: 'symbol',
          chainId,
        },
      ],
    });

    const accountBalance = walletAddress
      ? await readContract(wagmiConfig, {
          abi: erc20Abi,
          address: tokenAddress,
          functionName: 'balanceOf',
          args: [walletAddress],
          chainId,
        })
      : BigInt(0);

    return {
      decimals,
      name,
      symbol,
      userTokenBalance: accountBalance,
      userTokenFormatted: formatUnits(accountBalance, decimals),
      address: tokenAddress,
    };
  } catch (error: any) {
    if (error?.message) {
      console.log(error?.message);
    }

    return defaultData;
  }
};
